module.exports = __webpack_public_path__ + "img/56.eb0de526.jpg";